import cn from 'classnames'
import React from 'react'
import { formatPercentage, formatWAXInt } from '../helpers/FormatLinks'
import { useTranslation } from 'react-i18next'

export const VolumeDisplay = ({ collectionItem }) => {
    const {
        waxVolume24h,
        waxVolume7d,
        collectionType,
        growth24h,
        growth7d,
        customVolumeDisplay,
    } = collectionItem

    let title = ''
    let content = ''
    let showGrowth = true

    const { t } = useTranslation('common')

    const use24h = collectionType <= 2 || growth7d === undefined

    title = use24h ? t('collection.volume_24') : t('collection.volume_7d')
    content = use24h
        ? waxVolume24h
            ? formatWAXInt(waxVolume24h)
            : formatWAXInt(0)
        : waxVolume7d
        ? formatWAXInt(waxVolume7d)
        : formatWAXInt(0)

    const growth = use24h ? growth24h : growth7d

    return customVolumeDisplay ? (
        customVolumeDisplay
    ) : (
        <div className={'relative grid grid-cols-1 px-4  py-4 '}>
            <div
                className={cn(
                    'w-full dark:text-white text-black relative text-base font-light grid grid-cols-2',
                )}
            >
                <div className="">
                    <p className="font-semibold truncate">{content}</p>
                    <p
                        className={
                            'dark:!text-slate-400 text-black mx-auto text-xs font-semibold'
                        }
                    >
                        {title}
                    </p>
                </div>
                {showGrowth ? (
                    <div
                        className={cn(
                            'flex dark:text-white text-black text-base bg-transparent justify-end font-semibold items-center',
                            {
                                'text-positive': growth > 0,
                            },
                            {
                                'text-negative': growth < 0,
                            },
                        )}
                    >
                        {growth > 0 ? '+' : ''}
                        {formatPercentage(growth)}{' '}
                        {/* if growth pluw show plus, minus show minus, 0 show - */}
                        {growth > 0 ? (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={3}
                                stroke="currentColor"
                                className="ml-1 w-4 h-4 text-green-500"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
                                />
                            </svg>
                        ) : growth < 0 ? (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={3}
                                stroke="currentColor"
                                className="ml-1 w-4 h-4 text-red-500"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
                                />
                            </svg>
                        ) : growth === 0 ? (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={3}
                                stroke="currentColor"
                                className="ml-1 w-4 h-4 text-neutral"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M5 12h14"
                                />
                            </svg>
                        ) : null}
                    </div>
                ) : (
                    ''
                )}
            </div>
        </div>
    )
}
